import {atomWithStorage} from 'jotai/utils';
import type {RecipeMode} from 'views/admin/adminAiQueryApi';

/**
 * A CompanyOS data view the user pinned to their home page. Stores only the
 * (encoded) recipe + replay mode — never any data — so it stays small and is
 * re-run under the viewer's permissions every time it's rendered.
 */
export type SavedAiView = {
  /** Stable identity: replay mode + encoded recipe, so re-saving is idempotent. */
  id: string;
  title: string;
  /** URL-safe base64 recipe (see {@link encodeRecipe}). */
  recipe: string;
  mode: RecipeMode;
  savedAt: number;
};

/** Deterministic id for a (recipe, mode) pair so the same view never doubles up. */
export const makeSavedAiViewId = (recipe: string, mode: RecipeMode): string => `${mode}:${recipe}`;

/**
 * Home-pinned CompanyOS data views, persisted to localStorage. Intentionally
 * client-only ("nothing fancy") — these are personal shortcuts, not shared
 * state, and carry no results so there's nothing sensitive at rest.
 */
export const savedAiViewsAtom = atomWithStorage<SavedAiView[]>(
  'companyos-saved-ai-views',
  [],
  undefined,
  {getOnInit: true}
);
